import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Stack,
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMessage } from "../../../../base/MessageProvider";
import { hideLoadingOverlay, showLoadingOverlay } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewArtistProfile,
  fetchArtistDataById,
  getArtistById,
  updateArtistProfiles,
} from "../../../actions/artist";
import { CameraAlt, KeyboardBackspace, Verified } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import ReactTextInput from "../../../../components/ControllerComponent/ReactTextInput";
import ReactTelInput from "../../../../components/ControllerComponent/ReactTelInput";
import ReactSelect from "../../../../components/ControllerComponent/ReactSelect";
import {
  basicProfilecategory,
  contactPrivacyOptions,
  genderOptions,
  nationalityOptions,
} from "../../../../constants";
import ReactiveDatePickerField from "../../../../components/ControllerComponent/ReactDatePicker";
import {
  validationAddActorSchema,
  validationUpdateActorSchema,
} from "./validation";
import ReactLocationInput from "../../../../components/ControllerComponent/ReactLocationInput";
import OAuth from "../../OAuth";
import { useState } from "react";
import ImageUploadOptions from "../../../../components/ImageUploadOptions";
import { uploadProfilePicture } from "../../../actions/auth";

const ActorProfileForm = (props) => {
  const { open, onRefresh, navigation, addNew = false, onClose } = props;

  const [profileUploaderOpen, setProfileUploaderOpen] = useState(false);
  const [kycUploaderOpen, setKycUploaderOpen] = useState(false);
  // const [profileImage, setProfileImage] = useState(null);
  const [kycImageUrl, setKycImageUrl] = useState("");

  const alert = useMessage();
  const dispatch = useDispatch();
  const selectedArtist = useSelector(
    (state) => state.artistReducer?.selectedArtist
  );
  const locationList =
    useSelector((state) => state.generalReducer?.locationList) ?? [];
  const categoryList = useSelector(
    (state) => state.profileCategoryReducer?.profileCategoryList
  );

  const experienceYearsList =
    useSelector((state) => state.generalReducer?.experienceYearList) ?? [];

  const artistExperienceCategoryList =
    useSelector(
      (state) => state.generalReducer?.artistExperienceCategoryList
    ) ?? [];

  const artistExperienceCategoriesOption = useMemo(
    () =>
      artistExperienceCategoryList.map((item) => ({
        label: item,
        value: item,
      })),
    [artistExperienceCategoryList]
  );

  const experienceYearsOption = useMemo(
    () =>
      experienceYearsList.map((item) => ({
        label: item,
        value: item,
      })),
    [experienceYearsList]
  );

  const profileCategories = useMemo(
    () =>
      categoryList?.map((item) => ({
        label: item.name,
        value: item?.id,
      })),
    [categoryList]
  );

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      addNew ? validationAddActorSchema : validationUpdateActorSchema
    ),
  });

  const selectedCategory = watch("profileCategoryId");
  const isActor = selectedCategory === basicProfilecategory.ACTOR;
  const isModel = selectedCategory === basicProfilecategory.MODEL;
  const isInfluencer = selectedCategory === basicProfilecategory.INFLUENCER;

  const profilePic = watch("profileImage")
    ? URL.createObjectURL(watch("profileImage"))
    : null;

  console.log(watch("profileImage"), profilePic);

  useEffect(() => {
    setValue("profileImage", null);
    clearErrors();
    reset();
  }, [open]);

  useEffect(() => {}, [selectedCategory]);

  useEffect(() => {
    if (navigation.route === "ActorProfileForm") {
      clearErrors();
      console.log(
        "--------->",
        !!selectedArtist?.userProfile?.profileCategories?.find(
          (a) => a.id === basicProfilecategory.MODEL
        )
      );
      setValue("userId", selectedArtist?.userId ?? "");
      setValue("firstName", selectedArtist?.firstName ?? "");
      setValue("lastName", selectedArtist?.lastName ?? "");
      setValue(
        "profileCategoryId",
        selectedArtist?.userProfile?.profileCategory?.id
      );
      setValue(
        "isActor",
        !!selectedArtist?.userProfile?.profileCategories?.some(
          (a) => a.id === basicProfilecategory.ACTOR
        )
      );
      setValue(
        "isModel",
        !!selectedArtist?.userProfile?.profileCategories?.some(
          (a) => a.id === basicProfilecategory.MODEL
        )
      );
      setValue(
        "isInfluencer",
        !!selectedArtist?.userProfile?.profileCategories?.some(
          (a) => a.id === basicProfilecategory.INFLUENCER
        )
      );
      setValue(
        "experienceCategory",
        selectedArtist?.userProfile?.experienceCategory
      );
      setValue("experienceYears", selectedArtist?.userProfile?.experienceYears);
      setValue(
        "mobileNo",
        selectedArtist?.mobileNo
          ? `${selectedArtist.dialCode}${selectedArtist?.mobileNo}`
          : ""
      );
      setValue("email", selectedArtist?.email ?? "");
      setValue("contactVisibility", selectedArtist?.contactVisibility ?? "");
      setValue("gender", selectedArtist?.userProfile?.gender ?? "");
      setValue(
        "dob",
        selectedArtist?.userProfile?.dob
          ? new Date(selectedArtist?.userProfile?.dob)
          : null
      );
      setValue("bio", selectedArtist?.userProfile?.bio ?? "");
      setValue(
        "businessMobileNo",
        selectedArtist?.userProfile?.businessMobileNo
          ? `${selectedArtist?.dialCode}${selectedArtist?.userProfile?.businessMobileNo}`
          : ""
      );
      setValue(
        "businessEmail",
        selectedArtist?.userProfile?.businessEmail ?? ""
      );
      setValue("location", selectedArtist?.userProfile?.location ?? "");
      setValue("nationality", selectedArtist?.userProfile?.nationality ?? "");
    }
  }, [selectedArtist, navigation.route, open]);

  const onChangeCheckValue = (key, event) => {
    setValue(key, event?.target.checked);
  };

  const addSuccessCallBack = (res) => {
    const profileImage = watch("profileImage");
    if (profileImage && res?.data?.[0]?.userId) {
      const profilePicFormData = new FormData();
      profilePicFormData.append("file", profileImage);
      profilePicFormData.append("profileId", res?.data?.[0]?.userId);
      dispatch(
        uploadProfilePicture(
          profilePicFormData,
          (res) => {
            alert.showSuccess("Successfully added");
            onRefresh();
            onClose();
            hideLoadingOverlay();
          },
          (error) => {
            alert.showError(error?.message ?? "Something went wrong");
            hideLoadingOverlay();
          }
        )
      );
    } else {
      alert.showSuccess(res?.message ?? "Successfully added");
      onRefresh();
      onClose();
      hideLoadingOverlay();
    }
  };

  const updateSuccessCallBack = (res) => {
    alert.showSuccess(res?.message ?? "Successfully updated");
    dispatch(fetchArtistDataById({ profileId: selectedArtist.userId }));
    onRefresh();
    navigation?.goBack();
    hideLoadingOverlay();
  };

  const addHandler = async (data) => {
    showLoadingOverlay("Updating profile");
    await dispatch(
      addNewArtistProfile(data, addSuccessCallBack, (error) => {
        alert.showError(error?.message ?? "Something went wrong");
        hideLoadingOverlay();
      })
    );
  };

  const updateHandler = async (data) => {
    showLoadingOverlay("Updating profile");
    await dispatch(
      updateArtistProfiles(data, updateSuccessCallBack, (error) => {
        alert.showError(error?.message ?? "Something went wrong");
        hideLoadingOverlay();
      })
    );
    hideLoadingOverlay();
  };

  const onProfileUpload = () => {
    setProfileUploaderOpen(true);
  };
  const onKycUpload = () => {
    setKycUploaderOpen(true);
  };

  const handleProfilePic = (image) => {
    const file = image[0];
    setValue("profileImage", file);
  };
  const handleKycPic = (image) => {
    const file = image[0];
    const imageUrl = URL.createObjectURL(file);
    setKycImageUrl(imageUrl);

    console.log("Image URL: ", imageUrl);
    const formData = new FormData();
    formData.append("file", image[0]);
  };

  return (
    <Box className="h-full w-full flex flex-col justify-between pb-7 overflow-y-auto">
      <div>
        <div className="flex items-center py-5 px-4">
          {addNew ? null : (
            <IconButton onClick={navigation?.goBack}>
              <KeyboardBackspace />
            </IconButton>
          )}
          <h2 className="w-full text-center font-['Poppins-Semibold'] leading-[30px] text-[14px] ">
            {addNew ? "ADD" : "EDIT"} ARTIST
          </h2>
        </div>

        {addNew && (
          <>
            <div className="flex justify-center my-3 ">
              <div
                className={`flex justify-center items-center h-full space-x-6`}
              >
                <FormControl
                  error={errors?.profileImage?.message !== null}
                  fullWidth
                >
                  <div className="relative flex flex-col items-center">
                    <h3 className="mb-2">Profile Picture</h3>
                    <img
                      className="rounded-full w-28 h-28 border-[1px] border-gray-200"
                      src={
                        profilePic
                          ? profilePic
                          : require("../../../../assets/images/user-img.png")
                      }
                      alt="Profile"
                    />
                    <IconButton
                      onClick={onProfileUpload}
                      className="bg-[#2F80ED] text-white absolute bottom-0 right-0 p-2 transform translate-x-1/4 translate-y-1/4"
                    >
                      <CameraAlt className="text-lg" />
                    </IconButton>
                  </div>
                  {errors?.profileImage?.message && (
                    <FormHelperText
                      className="mt-2 font-['Poppins-Regular']"
                      id="component-error-text"
                    >
                      {errors?.profileImage?.message}
                    </FormHelperText>
                  )}
                </FormControl>
                {/* <div className="relative flex flex-col items-center">
                  <h3 className="mb-2">KYC Picture</h3>
                  <OAuth
                    altSrc={require("../../../../assets/images/user-img.png")}
                    component={
                      <img
                        className="rounded-full w-28 h-28 border-[1px] border-gray-200"
                        src={kycImageUrl}
                        // onClick={() =>
                        //   handleImageClick(selectedArtist?.kycMedia?.url)
                        // }
                        alt="KYC Picture"
                      />
                    }
                  />
                  <IconButton
                    onClick={onKycUpload}
                    className="bg-[#2F80ED] text-white absolute bottom-0 right-0 p-2 transform translate-x-1/4 translate-y-1/4"
                  >
                    <CameraAlt className="text-lg" />
                  </IconButton>
                </div> */}
              </div>
            </div>
            <Divider />
          </>
        )}

        <Divider />
        <Stack px={2} py={4} spacing={2}>
          <Stack direction={"row"} spacing={1}>
            <ReactTextInput
              hookFormControl={control}
              label="First Name"
              required
              varName="firstName"
              key={"firstName"}
              // readOnly={!addNew}
              errorMessage={errors?.firstName?.message}
            />
            <ReactTextInput
              hookFormControl={control}
              label="Last Name"
              varName="lastName"
              required
              key={"lastName"}
              // readOnly={!addNew}
              errorMessage={errors?.lastName?.message}
            />
          </Stack>
          <ReactTelInput
            hookFormControl={control}
            label="Mobile No"
            required
            varName="mobileNo"
            key={"mobileNo"}
            readOnly={!addNew}
            errorMessage={errors?.mobileNo?.message}
          />
          <ReactTextInput
            hookFormControl={control}
            label="Email"
            varName="email"
            required
            key={"email"}
            datatype="email"
            readOnly={!addNew}
            errorMessage={errors?.email?.message}
          />
          <ReactSelect
            hookFormControl={control}
            label="Contact Privacy"
            varName="contactVisibility"
            key={"contactVisibility"}
            required={addNew}
            withSelect={false}
            // readOnly={!addNew}
            options={contactPrivacyOptions}
            errorMessage={errors?.contactVisibility?.message}
          />
          <ReactSelect
            hookFormControl={control}
            label="Category"
            varName="profileCategoryId"
            required
            key={"profileCategoryId"}
            onChange={() => {
              setValue("isActor", false);
              setValue("isModel", false);
              setValue("isInfluencer", false);
            }}
            // readOnly={!addNew}
            options={profileCategories}
            errorMessage={errors?.profileCategoryId?.message}
          />
          {selectedCategory && (
            <Stack
              direction={"row"}
              spacing={1}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {isModel && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={watch("isActor")}
                      onChange={onChangeCheckValue?.bind(this, "isActor")}
                      sx={{ "&.Mui-checked": { color: "#2F80ED" } }}
                      size="small"
                    />
                  }
                  componentsProps={{
                    typography: {
                      className:
                        "font-['Poppins-Regular'] font-[400] text-[11px] text-[#1F1E1E]",
                    },
                  }}
                  label="Are you an Actor?"
                />
              )}
              {isActor && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={watch("isModel")}
                      onChange={onChangeCheckValue?.bind(this, "isModel")}
                      sx={{ "&.Mui-checked": { color: "#2F80ED" } }}
                      size="small"
                    />
                  }
                  componentsProps={{
                    typography: {
                      className:
                        "font-['Poppins-Regular'] font-[400] text-[11px] text-[#1F1E1E]",
                    },
                  }}
                  label="Are you a Model?"
                />
              )}
              {!isInfluencer && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={watch("isInfluencer")}
                      onChange={onChangeCheckValue?.bind(this, "isInfluencer")}
                      sx={{ "&.Mui-checked": { color: "#2F80ED" } }}
                      size="small"
                    />
                  }
                  componentsProps={{
                    typography: {
                      className:
                        "font-['Poppins-Regular'] font-[400] text-[11px] text-[#1F1E1E]",
                    },
                  }}
                  label="Are you an Influencer?"
                />
              )}
            </Stack>
          )}
          <ReactSelect
            hookFormControl={control}
            label="Experience Category"
            required={addNew}
            varName="experienceCategory"
            key={"experienceCategory"}
            withSelect={false}
            options={artistExperienceCategoriesOption}
            errorMessage={errors?.experienceCategory?.message}
          />
          <ReactSelect
            hookFormControl={control}
            label="Work Experience"
            varName="experienceYears"
            key={"experienceYears"}
            required={addNew}
            withSelect={false}
            options={experienceYearsOption}
            errorMessage={errors?.experienceYears?.message}
          />
          <ReactLocationInput
            placeholder="Eg. Mumbai, Maharashtra"
            label="Based In"
            hookFormControl={control}
            required={addNew}
            varName="location"
            errorMessage={errors?.location?.message}
            options={locationList}
          />

          <ReactSelect
            hookFormControl={control}
            label="Gender"
            varName="gender"
            key={"gender"}
            required
            // readOnly={!addNew}
            options={genderOptions}
            errorMessage={errors?.gender?.message}
          />
          <ReactiveDatePickerField
            hookFormControl={control}
            label={"Date of Birth"}
            varName={"dob"}
            required={addNew}
            // readOnly={!addNew}
            errorMessage={errors?.dob?.message}
            maxDate={new Date()}
            // minDate={new Date()}
          />
          <ReactTextInput
            hookFormControl={control}
            label={"Bio"}
            varName="bio"
            key={"bio"}
            rows={3}
            maxLength={600}
            isMultiLine
            // readOnly={!addNew}
            errorMessage={errors?.bio?.message}
          />

          <ReactTelInput
            hookFormControl={control}
            label="Business Mobile No"
            required={addNew}
            varName="businessMobileNo"
            key={"businessMobileNo"}
            errorMessage={errors?.businessMobileNo?.message}
          />
          <ReactTextInput
            hookFormControl={control}
            label="Business Email"
            required={addNew}
            varName="businessEmail"
            key={"businessEmail"}
            datatype="email"
            errorMessage={errors?.businessEmail?.message}
          />
          {/* {addNew ? ( */}
          <ReactSelect
            hookFormControl={control}
            label="Nationality"
            varName="nationality"
            key={"nationality"}
            // readOnly={!addNew}
            options={nationalityOptions.map(({ label }) => ({
              label,
              value: label,
            }))}
            errorMessage={errors?.nationality?.message}
          />
          {/* ) : null} */}
        </Stack>
        <Divider />
        <div className="flex flex-col justify-between items-center gap-2 py-5 px-5">
          <Button
            onClick={handleSubmit(addNew ? addHandler : updateHandler)}
            variant="contained"
            className="w-full font-['Poppins-Medium'] normal-case text-[14px] text-white"
          >
            {!addNew ? "UPDATE" : "ADD"}
          </Button>
        </div>
      </div>

      <ImageUploadOptions
        open={profileUploaderOpen}
        hideCamera={true}
        onClose={setProfileUploaderOpen?.bind(null, false)}
        onSubmit={handleProfilePic}
      />
      <ImageUploadOptions
        open={kycUploaderOpen}
        hideCamera={true}
        onClose={setKycUploaderOpen?.bind(null, false)}
        onSubmit={handleKycPic}
      />
    </Box>
  );
};

export default ActorProfileForm;
